import React from 'react';
import Parent from '../parent';
import { withTranslation } from 'react-i18next';
import {BllinkLogger} from "../utils/bllink_loggers";
import {Currency} from '../currency';
import $ from 'jquery';
import './unPaidMonths.css';


export class UnpaidMonths extends Parent {

    constructor(props) {
        super();
        this.state = {
            months: props.months || [],
        }

        this.logger.info('UnpaidMonths ', props)

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.months !== prevState.months || nextProps.rewards !== prevState.rewards) {
            return {
                months: nextProps.months || [],
                // https://app.asana.com/0/1196545425570329/1200307774346154 reward experiment
                rewards: nextProps.rewards,
            };
        }
        return null;
    }

    async componentDidMount() {
        await this.bindDoubleClickToAddOrEdit();

        const thisObj = this;
        $(document).ready(function () {
            thisObj.bindPopUpClicks(thisObj, 'months')
        });
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        await this.bindDoubleClickToAddOrEdit();
    }

    async bindDoubleClickToAddOrEdit(){
        const isViewedAsManager = await this.isLoggedIn();
        if (isViewedAsManager) {
            let thisObj = this;
            $('.js-amount, .js-part-pay').unbind('dblclick').bind('dblclick', function (e) {
                thisObj.handlePartPayDoubleClicked(e)
            })
        }
    }

    renderPartPayAmountIfNeeded(value, props){
        return this.renderPartPayAmount(value, props)
    }

    renderRewardsIfNeeded(value, relevantReward){
        const {t} = this.props

        if (relevantReward){
            let amountLeftAfterReward = value.amount_left.value - relevantReward.value;
            if (amountLeftAfterReward < 0){
                console.log(`amountLeftAfterReward ${amountLeftAfterReward}  value.amount_left.value ${value.amount_left.value} relevantReward.value ${relevantReward.value}`)
                throw Error(`negative amount for apartment after reward`)
            }

            return (<span id={'reward-amount'} className={'js-amount js-reward reward-amount is-render break'}
                          time-index={`${value.month}-${value.year}`}
                          // full-amount={value.amount_left.value}
                          value={`${amountLeftAfterReward}`}
                          currency={relevantReward.currency}
                        >
                          {amountLeftAfterReward} <Currency>{relevantReward.currency}</Currency>
                    </span>);
            }
    }


    getRelevantReward(index, props) {
        if (props.rewards) {
            let firstReward = props.rewards[0]
            if (firstReward) {
                const isMonthEntitleForReward = firstReward.months.length - 1 >= index;
                if (isMonthEntitleForReward) {
                    return firstReward.months[index];
                }
            }
        }
    }


    renderNormalAmount(value, index, props, relevantReward){
        const {t} = props;

        let normalAmountHtml = (<span className={'js-amount'}
                                 time-index={`${value.month}-${value.year}`}
                                 full-amount={value.amount_left.value}
                                 currency={value.amount_left.currency}>
                                    {value.amount_left.value} <Currency>{value.amount_left.currency}</Currency>
                                </span>);

        if (!relevantReward){
            return (normalAmountHtml)
        }else{
            // https://app.asana.com/0/1196545425570329/1200307774346154 reward experiment
            return (<del><div id={'reward-striked'}>{normalAmountHtml}</div></del>)
        }
    }

    render() {

        const {t} = this.props;
        BllinkLogger.info('un paid months state', this.state)

        return (
            <div className="unpaid-payment col-md-12">
                <div className="month-grid">
                    {
                        this.state.months.map((value, index) => {
                            let isPartPay = (value.part_pay && value.part_pay.value);
                            BllinkLogger.info(`value for months`, value);
                            let reward = this.getRelevantReward(index, this.props);
                            let additionalPartPayClass = isPartPay || reward ? 'label_part_pay' : '';
                            return (
                                <div key={index} className="month-item">
                                    <div className="inline_layout">
                                        <label className={`label_container ${additionalPartPayClass}`}>
                                            <input
                                                type="checkbox"
                                                checked={value.selected}
                                                amount={value.amount_left.value}
                                                item-number={index}
                                                onChange={this.props.onChangeFunc}
                                            />
                                            <span className="checkmark"/>
                                            <div className="checkamount">
                                                {this.renderRewardsIfNeeded(value, reward)}
                                                {this.renderPartPayAmountIfNeeded(value, this.props)}
                                                {this.renderNormalAmount(value, index, this.props, reward)}
                                            </div>
                                            <div className="checktext">
                                                {t('common.monthsShort.' + value.month)}<br/>{' '}{value.year}
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )

    }
}


export default withTranslation()(UnpaidMonths);
